<template>
  <div>
    <!-- <div style="text-align: center;background: #fff;margin-bottom: 10px;padding: 20px;"><img style="width: 70%;"
        src="@/assets/images/lunbo/new.jpg" /></div> -->
    <evaluate></evaluate>
    <lunboTwo></lunboTwo>
    <div class="title">
      <span class="iconLeft"></span>
      <h2>案例列表</h2>
      <span class="iconRight"></span>
    </div>
    <div style="padding: 10px 20px;margin-top: 20px;max-width: 1600px;margin: 0 auto;margin-top: 40px;">
      <CommonTable :columns="columns" :dataSource="projectList" :total="total" :currentPage="currentPage"
        :pageSize="pageSize" @pageChange="handlePageChange" @sizeChange="handleSizeChange" @refresh="handleRefresh"
        @reset="handleReset">
        <template slot="completionUnit" slot-scope="scope">
          <el-popover placement="right-start" width="300" trigger="hover" :content="scope.completionUnit">
            <div  slot="reference" class="two-line-text">
              {{ scope.completionUnit }}
            </div>
          </el-popover>
        </template>
        <template slot="inviteExpertList" slot-scope="scope">
          <el-popover placement="right-start" width="300" trigger="hover">
            <div>
              <span v-for="value in scope.inviteExpertList">
                {{ value.expertName  }}({{value.unitName || '暂无单位' + '  '}}) <span v-if="scope.inviteExpertList.length >1">;</span>
              </span>
            </div>
            <div slot="reference" class="two-line-text">
              <span v-for="value in scope.inviteExpertList">
                {{ value.expertName  }}({{value.unitName || '暂无单位' + '  '}}) <span v-if="scope.inviteExpertList.length >1">;</span>
              </span>
            </div>
          </el-popover>
        </template>
      </CommonTable>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from '../../components/Footer.vue';
import { evaluationPage } from '@/api/account';
import CommonTable from '../../components/CommonTable.vue';
import lunboTwo from '../../components/lunboTwo.vue';
import evaluate from './evaluate.vue';

export default {
  name: 'ProjectList',
  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 10,
      projectList: [],
      columns: [
        { title: '项目领域', dataIndex: 'projectArea', width:240,key: 'projectArea', align: 'center', customCell: () => {
            return {
              style: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        {
          title: '项目名称',
          dataIndex: 'projectName',
          key: 'projectName',
          align: 'center',
          customRender: (text) => this.maskProjectName(text),
           customCell: () => {
            return {
              style: {
                verticalAlign: 'middle'
              }
            }
          },
        },
        {
          title: '完成单位',
          key: 'completionUnit',
          align: 'center',
          scopedSlots: { customRender: 'completionUnit'},
          customCell: () => {
            return {
              style: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        {
          title: '专家信息',
          key: 'inviteExpertList',
          align: 'center',
          scopedSlots: { customRender: 'inviteExpertList'},
          customCell: () => {
            return {
              style: {
                verticalAlign: 'middle'
              }
            }
          }
        },
        { title: '评价结论', dataIndex: 'evaluationConclusion', key: 'evaluationConclusion', 
          align: 'center',width:120,
          customCell: () => {
            return {
              style: {
                verticalAlign: 'middle'
              }
            }
          },
        },
      ]
    };
  },
  components: {
    Footer,
    CommonTable,
    lunboTwo,
    evaluate
  },
  created() {
    this.fetchTableData();
  },
  methods: {
    /**
     * 项目名称脱敏 最终版
     * 1. ≤6个字：显示前后各2字，中间*
     * 2. ＞6个字：中间6个字*
     */
    maskProjectName(text) {
      if (!text) return '';
      const str = String(text);
      const len = str.length;

      // 长度 <=6：显示前后各2个字，中间脱敏
      if (len <= 6) {
        if (len <= 2) return str + '**'; // 不足2个字 后面补*
        if (len === 3) return str[0] + '*' + str[2];
        if (len === 4) return str.slice(0, 2) + '**';
        // 5/6个字：前2 + 后2，中间*
        return str.slice(0, 2) + '***' + str.slice(-2);
      }

      // 长度 >6：中间固定6个*
      const keep = Math.floor((len - 6) / 2);
      return str.slice(0, keep) + '******' + str.slice(-keep);
    },

    async fetchTableData() {
      evaluationPage({
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        projectStatus:3,
      }).then((res) => {
        if (res.code == 200) {
          this.projectList = res.data.pageRecords;
          this.total = res.data?.pagination?.totals;
        }
      });
    },

    handlePageChange(page, size) {
      this.currentPage = page;
      this.pageSize = size;
      this.fetchTableData();
    },
    handleSizeChange(page, size) {
      this.currentPage = page;
      this.pageSize = size;
      this.fetchTableData();
    },
    handleRefresh() {
      this.fetchTableData();
    },
    handleReset() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.fetchTableData();
    },
  }
};
</script>

<style scoped>
.project-list-section {
  background-color: #fff;
  border-top: 3px solid #1e90ff;
  position: relative;
  margin: 20px 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(65, 105, 225, 0.1);
  margin: 10px;
  padding: 10px;
  margin-bottom: 0px;
  margin-top: 6px;
}

.project-list-section::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 100px;
  height: 3px;
  background-color: #ffd700;
}

.project-table {
  border-bottom: 1px solid #4169e1;
  padding: 0;
}

.project-header {
  padding: 18px 20px;
  background-color: rgba(65, 105, 225, 0.05);
  border-bottom: 1px solid #4169e1;
}

.header-title {
  margin: 0;
  font-size: 16px;
  color: #1e90ff;
  font-weight: 600;
}

.project-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 28px 20px;
  border-top: 1px solid #4169e1;
  font-size: 15px;
  color: #333;
  background-color: rgba(255, 255, 255, 0.6);
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.project-item:hover {
  background-color: rgba(255, 255, 255, 0.9);
  transform: translateX(2px);
}

.project-name {
  flex: 1;
  font-weight: 500;
  line-height: 1.6;
  color: #2c3e50;
}

.project-meta {
  display: flex;
  gap: 30px;
  white-space: nowrap;
  align-items: center;
}

.meta-item {
  color: #59698d;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: rgba(65, 105, 225, 0.05);
}

.eval-result {
  color: #1e90ff;
  font-weight: 600;
  background-color: rgba(30, 144, 255, 0.1);
}

@media (max-width: 768px) {
  .project-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
    padding: 22px 16px;
  }

  .project-meta {
    gap: 20px;
    flex-wrap: wrap;
  }
}

@media (max-width: 576px) {
  .project-item {
    padding: 18px 12px;
  }

  .header-title {
    font-size: 14px;
  }
}

.two-line-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  line-height: 1.5;
  max-height: 3em;
  text-align: center;
}
.title {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center; 
  margin-bottom: 60px; 
  padding-top: 60px;

  h2 {
    font-weight: 800;
    font-size: 30px;
    color: #232323;
    line-height: 24px;
    margin: 0; 
  }
}

.iconLeft {
  width: 115px;
  height: 27px;
  margin-right: 17px;
  background-image: url('~@/assets/images/arrowBlue.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  display: inline-block;
}

.iconRight {
  display: inline-block;
  width: 115px;
  height: 27px;
  margin-left: 17px;
  background: url(~@/assets/images/arrowBlue.png) no-repeat center / cover;
  transform: rotateY(180deg);
}
</style>